var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.007 16.933V7.037c0-.934 1.127-1.403 1.79-.746l4.97 4.926a1.05 1.05 0 01.003 1.488l-4.97 4.97c-.662.662-1.793.193-1.793-.742z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik05LjAwNzMyIDE2LjkzMjhWNy4wMzY1OUM5LjAwNzMyIDYuMTAzMzkgMTAuMTMzNyA1LjYzMzkgMTAuNzk2NSA2LjI5MDgxTDE1Ljc2NjcgMTEuMjE2OUMxNi4xNzk5IDExLjYyNjQgMTYuMTgxNCAxMi4yOTM3IDE1Ljc3IDEyLjcwNTFMMTAuNzk5OCAxNy42NzUzQzEwLjEzODMgMTguMzM2OCA5LjAwNzMyIDE3Ljg2ODMgOS4wMDczMiAxNi45MzI4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg24 as ReactComponent };